module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_malawi-80793727.png";